<template>
  <div id="student-management">
    <form v-on:submit.prevent="doSubmit">
      <card v-for="webConfig in webConfigs" :key="webConfig.id">
        <b-row>
          <b-col cols="12" class="">
            <fg-input :required="true" for-input="name" :type="webConfig.field" :name="webConfig.key_name" :id="webConfig.key_name" :label="webConfig.name" placeholder="Masukkan" v-model="webConfig.value" />
          </b-col>
        </b-row>
      </card>
      <card>
        <save-data-button :disabled="saveButtonData.isLoading" :is-create="false" :state="saveButtonData.isLoading && saveButtonData.state === 1 ? 2 : saveButtonData.state" :is-loading="saveButtonData.isLoading" />
        <cancel-button/>
      </card>
    </form>
  </div>
</template>
<script>
  import { Input, Checkbox, Switch } from 'element-ui'
  import PaginatedTable from '@/components/Tables/PaginatedTable'
  import SaveData from '@/components/Buttons/SaveData'
  import Cancel from '@/components/Buttons/Cancel'

  export default {
    components: {
      [Input.name]: Input,
      PaginatedTable,
      elCheckbox: Checkbox,
      SaveDataButton: SaveData,
      CancelButton: Cancel,
      LSwitch: Switch
    },
    data () {
      return {
        apiUrl: window.AppConfig.apiUrl + 'web-configs',
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        webConfigs: []
      }
    },
    methods: {
      getWebConfig () {
        this.$http.get(this.apiUrl).then(response => {
          this.webConfigs = response.data.data
        })
      },
      doSubmit () {
        this.$http.post(this.apiUrl, {
          'web_configs': this.webConfigs
        }).then(response => {
          this.saveButtonData.isLoading = false
          this.$store.dispatch('notification/success', 'Web Config berhasil diperbarui.')
          this.getWebConfig()
        }).catch(error => {
          this.saveButtonData.isLoading = false
          this.$store.dispatch('notification/error', error)
        })
      }
    },
    mounted () {
      this.getWebConfig()
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Settings/WebConfig/Index.vue